import moment from 'moment'

import { getBnoCategory, getValidWhoInnerCodes, getValidMcodes } from "@/utils/bnoCategoriesUtil"

const dateFormats = [
  moment.ISO_8601,
  "YYYY-MM-DD"
]

const commandMap = {
  bno:
    (value, validation_value, inputs) => commandMap[validation_value](value, validation_value, inputs),

  who:
    (value, validation_value, inputs) => getValidWhoInnerCodes(getBnoCategory(inputs['bno'])).includes(value),

  mcode:
    (value, validation_value, inputs) => getValidMcodes(getBnoCategory(inputs['bno'])).includes(value),

  elementOf:
    (value, validation_value, inputs) => validation_value.includes(value),

  not:
    (value, validation_value, inputs) => !commandMap[Object.keys(validation_value)[0]](value, validation_value[Object.keys(validation_value)[0]], inputs),

  type:
    (value, validation_value, inputs) => commandMap[validation_value](value, validation_value, inputs),

  required:
    (value, validation_value, inputs) => value != null && value,

  maxLength:
    (value, validation_value, inputs) => !value || value.length <= validation_value,

  exactLength:
    (value, validation_value, inputs) => !value || value.length === validation_value,

  number:
    (value, validation_value, inputs) =>
    {
      return !value || Number.isFinite(Number(value))
    },

  onlyNumber: (value, validation_value, inputs) =>
  {
    return !!value.match(/^\d+$/) === validation_value
  },

  greaterOrEqualThan:
    (value, validation_value, inputs) => {
      const other_value = inputs[validation_value]
      return !value || (Number.isFinite(Number(value)) && Number.isFinite(Number(other_value)) && Number(value) >= Number(other_value))
    },

  lessOrEqualThan:
    (value, validation_value, inputs) => {
      const other_value = inputs[validation_value]
      return !value || (Number.isFinite(Number(value)) && Number.isFinite(Number(other_value)) && Number(value) <= Number(other_value))
    },

  date:
    (value, validation_value, inputs) => !value || moment(value, dateFormats, true).isValid(),

  labor:
    (value, validation_value, inputs) => {
      if(!value) {
        return {
          normal_min: true,
          normal_max: true,
          ertek: true,
          mertekegyseg: true
        }
      }
      return {
        normal_min: commandMap.lessOrEqualThan(value.normal_min, 'normal_max', value) && commandMap.number(value.normal_min),
        normal_max: commandMap.greaterOrEqualThan(value.normal_max, 'normal_min', value) && commandMap.number(value.normal_max),
        ertek: commandMap.number(value.ertek),
        mertekegyseg: commandMap.maxLength(value.mertekegyseg, 50)
      }
    },

  hasContent: (value, validation_value, inputs) => {
    return !value || !!inputs[validation_value]
  },

  onlyIf: (value, validation_value, inputs) => {
    return !commandMap.elementOf(value, validation_value[0]) || commandMap.elementOf(inputs[validation_value[1]], validation_value[2])
  }
}

export const isLaborValid = (value) => {
  return commandMap.labor(value)
}

export const isValid = (value, validation, inputs) => validation.every((validation_item) => {
  return commandMap[Object.keys(validation_item)[0]](value, validation_item[Object.keys(validation_item)[0]], inputs)
})

const validationDictionary = {
  bno: () => '',
  who: () => '',
  mcode: () => '',
  elementOf: () => '',
  not: () => '',
  type: (value) => validationDictionary[value]() + ' típusú',
  required: () => 'kitöltendő',
  maxLength: (value) => 'maximum ' + value + ' karakter hosszú',
  exactLength: (value) => value + ' karakter hosszú',
  number: () => 'szám',
  onlyNumber: () => 'szám',
  greaterOrEqualThan: () => '',
  lessOrEqualThan: () => '',
  date: () => 'dátum',
  labor: () => 'labor',
  hasContent: () => 'szülő mező tartalmaz adatot',
  onlyIf: () => ''
}

const validationObjectToString = (validationObject) => {
  const key = Object.keys(validationObject)[0]
  const value = validationObject[key]
  return validationDictionary[key](value)
}

export const createHelpText = (validation, validationText) => {
  if (validationText) {
    return validationText
  }

  if (validation === null || validation === 'labor') {
    return ""
  }

  let separator = ' '
  return validation.reduce((resultString, validationObject) => {
    const result = resultString + separator + validationObjectToString(validationObject)
    separator = ', '
    return result
  }, 'Kötelezően ')
}
